import meta from "./meta";
import projectThumbPlaceholder from "./projectThumbPlaceholder";

export default `
${meta}
${projectThumbPlaceholder}
`;
